import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BillsRoutingModule } from './bills-routing.module';
import { BillsListComponent } from './components/bills-list/bills-list.component';
import { BillService } from './services/bill.service';
import { ConstsHelper } from '../../helpers/consts.helper';
import { billsReducer } from './store/reducers/bills.reducer';
import { BillsEffects } from './store/effects/bills.effects';
import { ModalBillsListComponent } from './components/modal-bills-list/modal-bills-list.component';
import { billReducer } from './store/reducers/bill.reducer';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [BillsListComponent, ModalBillsListComponent],
  imports: [
    CommonModule,
    BillsRoutingModule,
    StoreModule.forFeature(ConstsHelper.REDUCER_BILLS, billsReducer),
    StoreModule.forFeature(ConstsHelper.REDUCER_BILL, billReducer),
    EffectsModule.forFeature([BillsEffects]),
    SharedModule
  ],
  providers: [BillService]
})
export class BillsModule { }
